webpackJsonp([224175451610025],{

/***/ 1453:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"IntervalConfigInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"amountCents","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"defaultValue":null,"description":null,"name":"percent","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"defaultValue":null,"description":null,"name":"statementNote","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"type","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"ENUM","name":"BillingGroupFeeType","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-interval-config-input-f54c3d49dd6459a93529.js